import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)
/**
 * Login Callout 4 Authenticate with Heroku
 * @param {Object} param0
 * @param {String} param0.id_token
 */
export const login = ({ id_token }) => {
  return req.get('/users/login', {
    headers: {
      Authorization: id_token
    }
  })
}
/**
 * Logout user
 * @param {String} authToken Bearer ${token}
 */
export const logout = (authToken) => {
  return req.get('/users/logout', {
    headers: {
      Authorization: authToken
    }
  })
}
/**
 * User session
 * @param {String} authToken Bearer ${token}
 */
export const session = (authToken) => {
  return req.get('/users/session', {
    headers: {
      Authorization: authToken
    }
  })
}
/**
 * Verify Email address
 * @param {String} verificationToken
 */
export const verifyEmail = (recoveryToken, digitalId, sfid) => {
  return req.post('/users/verify-email', {
    recoveryToken,
    digitalId,
    sfid
  })
}
/**
 * RESET PASSWORD
 * @param {String} loginId
 */
export const resetPassword = (loginId) => {
  const data = {
    loginId: loginId
  }
  return req.post('/users/reset-password', data)
}


/**
 * UPDATE DONOR EMAIL
 */
export const updateAccountSetting = (userAccountSettings, token) => {
  const {currentEmail,
    newEmail,
    confirmEmail
  } = userAccountSettings
 
  const data = {
    currentEmail,
    newEmail,
    confirmEmail
   }
  return req.put('/users/login-details', data, {
    headers: {
      Authorization: token
    }
  })
}

/**
 * MERGE DONOR EMAIL
 */
 export const mergeAccountSetting = (mergeAccountSettings, token) => {
  const {currentEmail,
    newEmail,
    confirmEmail,
    forceMerge
  } = mergeAccountSettings
 
  const data = {
    currentEmail,
    newEmail,
    confirmEmail,
    forceMerge
   }
  return req.put('/users/merge-account', data, {
    headers: {
      Authorization: token
    }
  })
  
}

/**
 * Resend donor Verification mail
 */
 export const resendVerification = (sfid, token) => {
 
  const data = {
    sfid:sfid
   }
   return req.post('/users/send-verification', data, {
      headers: {
        Authorization: token
      }
    })
  
}

/**
 * GET ACTIVE SESSION
 */
export const getSession = () => {
  return req.get('​/users​/session')
}

export const verifyStandardEmailAndPassword = (username, password) => {
  return req.post('/users/migration/registration', {
    loginId: username,
    password: password
  })
}

export const getMigrationStatus = (username) => {
  return req.get('/users/migration/verify-user', {
    params: {
      loginId: username
    }
  })
}

export const changePassword = (loginId, oldPassword, newPassword) => {
  return req.post('/users/migration/change-password', {
    loginId,
    oldPassword,
    newPassword
  })
}

export const loginWithEmail = (oldId, password, newId) => {
  return req.post('/users/migration/register-email', {
    loginId: oldId,
    password: password,
    emailId: newId
  })
}

export const socialLoginWithEmail = (email) => {
  return req.post('/users/migration/social-login', {
    emailId: email
  })
}

export const setupNewPassword = (flowType, token, password, sfid) => {

  if(flowType === 'expired-account'){
    return req.post('users/registration/verify-expired-account', {
      newPassword: password,
      token: token,
      sfid: sfid
    })
  }else{
    return req.post('/users/migration/verify-token', {
      newPassword: password,
      token: token,
      flow: flowType
    })
  }
  
}

export const migrationResetPassword = (email) => {
  return req.get('/users/migration/forgot-password', {
    params: {
      loginId: email
    }
  })
}

export const accessCenters = (email) => {
  return req.get('users/access-centers', {
    params: {
      loginId: email
    }
  })
}

export const changeDefaultCenter = (userSfid, center, token) => {
  const data = {
    userSfid: userSfid,
    centerSfid: center
   }
  return req.put('/users/default-center', data, {
    headers: {
      Authorization: token
    }
  })
}

export const edqAuth = (token) => {
  return req.get('/edq/auth', {
    headers: {
      Authorization: token
    }
  })

}
